'use client';

import { useCallback, useEffect, useState } from 'react';
import TapToRemoveMarker from '@alltrails/maps/components/TapToRemoveMarker/TapToRemoveMarker';
import useMap from '@alltrails/maps/hooks/useMap';
import { useAppDispatch, useAppSelector } from '@/utils/redux';
import { setStreetAddressLngLat } from '@/utils/slices/exploreSlice';

const StreetAddressMapMarker = () => {
  const map = useMap();
  const dispatch = useAppDispatch();
  const streetAddressLngLat = useAppSelector(state => state.explore.streetAddressLngLat);

  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    // On render of this marker, we want to show the tooltip so that users (especially mobile)
    // know to tap on the marker to remove it. Dismiss the tooltip automatically after a couple of seconds.
    // Since this marker is rendered when a user selects a street address and the map must pan to that spot,
    // wait to show the tooltip and start the timer until the map is done panning.
    if (streetAddressLngLat) {
      const onMoveEnd = () => {
        setShowTooltip(true);
        setTimeout(() => {
          setShowTooltip(false);
        }, 2500);
      };

      onMoveEnd && map?.once('moveend', onMoveEnd);
      return () => {
        onMoveEnd && map?.off('moveend', onMoveEnd);
      };
    }
    return;
  }, [dispatch, map, streetAddressLngLat]);

  const removeStreetAddressMarker = useCallback(() => {
    setShowTooltip(false);
    dispatch(setStreetAddressLngLat(undefined));
  }, [dispatch]);

  return (
    streetAddressLngLat && (
      <TapToRemoveMarker
        latitude={streetAddressLngLat[1]}
        longitude={streetAddressLngLat[0]}
        onRemove={removeStreetAddressMarker}
        setShowTooltip={setShowTooltip}
        showTooltip={showTooltip}
      />
    )
  );
};

export default StreetAddressMapMarker;
